import React from 'react';
import PropTypes from 'prop-types';

import QuestionGroup from './QuestionGroup';

import Select from 'apps/ask/components/formElements/Select';
import DropdownInput from 'apps/ask/components/formElements/Dropdown';
import Input from 'apps/ask/components/formElements/Input';
import RangeInput from 'apps/ask/components/formElements/Range';
import SexSelector from 'apps/ask/components/formElements/SexSelector';

import questionTypes from '../../data/questionnaire/questionTypes';

class Question extends React.Component {

  constructor(props) {
    super(props);

    this.state = this.resolveState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (!props.submitting) { this.setState(this.resolveState(props)); }
  }

  resolveState(props) {
    const question = props.question;
    const answer = props.answers.find(a => a.id == question.id);
    const choice = answer ? answer.choice_id : undefined;

    return { answers: props.answers, question, choice, title: question.name };
  }

  render() {
    return (
      <div className='questionnaire__item'>
        { this.state.question.name && this.renderQuestionTitle() }
        { this.renderQuestionComponent() }
      </div>
    );
  }

  componentDidMount() {
    if (this.state.choice) { this.props.onAnswer(this.state.question.id, this.state.choice, null, true); }
  }

  renderQuestionTitle() {
    const title = this.state.question.name;

    return (this.props.mainQuestion) ? <h2>{title}</h2> : <h4>{title}</h4>;
  }

  renderQuestionComponent() {
    const { question, answers, choice } = this.state;
    const { submitting } = this.props;

    switch(question.type) {
    case questionTypes.questionGroup:
      return (
        <QuestionGroup
          title={question.text}
          answers={answers}
          questions={question.items}
          onAnswer={this.onAnswer.bind(this)}
        />
      );
    case questionTypes.dropdown:
      return (
        <DropdownInput
          choices={question.choices}
          selectedChoice={choice}
          onSelectionChange={this.onAnswer.bind(this, question.id)}
          options={question.options}
        />
      );
    case questionTypes.numberInput:
      return (
        <Input
          type="number"
          value={choice || question.initialValue}
          placeholder={question.placeholder}
          min={question.min}
          max={question.max}
          onChange={this.onAnswer.bind(this, question.id)}
        />
      );
    case questionTypes.rangeInput:
      return (
        <RangeInput
          initialValue={choice ? parseInt(choice) : undefined}
          onRangeInput={this.onAnswer.bind(this, question.id)}
        />
      );
    case questionTypes.sexSelector:
      return (
        <SexSelector
          choices={question.choices}
          selectedChoice={choice}
          onSelection={this.onAnswer.bind(this, question.id)}
        />
      );
    default:
      return (
        <Select
          choices={question.choices}
          selectedChoice={choice}
          onSelection={this.onAnswer.bind(this, question.id)}
          submitting={submitting}
        />
      );
    }
  }

  onAnswer(id, choice, overrideID, answered) {
    let isAnswered = answered;

    if (isAnswered === undefined) {
      isAnswered = this.state.question.optional ? true : ((choice) ? true : false);
    }

    this.props.onAnswer(id, choice, overrideID, isAnswered);
  }
}

Question.defaultProps = {
  answers: [],
  mainQuestion: false,
  submitting: false
};

Question.propTypes = {
  mainQuestion: PropTypes.bool,
  submitting: PropTypes.bool,
  question: PropTypes.object,
  answers: PropTypes.array,
  onAnswer: PropTypes.func.isRequired
};

export default Question;
